import React from 'react';
import { ContainerFlex, Container, Card } from './styled/Styled';

const TopicItem = ({ item, index }) => {
    return (
        <ContainerFlex multiline={false} width="12" lg="6" align="flex-start" pv="16" >
            <Card minwidth="30px" idealwidth="30px" textAlign="center"
                border="solid" borderColor="color-white" color="color-black" borderWidth="1px" fontColor="color-white" radius="10px" children={index + 1} />
            <Container ml="16" key={index} children={item.text} />
        </ContainerFlex>
    );
};

export default TopicItem;